export class Character {
    constructor(id, config) {
        this.x = 0;
        this.z = 0;
        this.id = id;
        this.config = config;
    }
    stepTile(pos) {
        this.x = pos.x;
        this.z = pos.z;
    }
    *tick() { }
}
export class World {
    constructor(level, xoffset, zoffset, w, h) {
        this.npcs = [];
        this.charidcounter = 1;
        this.xoffset = 0;
        this.zoffset = 0;
        this.width = 0;
        this.height = 0;
        this.cachedChunks = [];
    }
    async preloadChunks() {
    }
    loadFromPreloads() {
    }
    moveGrid(xoffset, zoffset, w, h) {
        this.xoffset = xoffset;
        this.zoffset = zoffset;
        this.width = w;
        this.height = h;
    }
    addCharacter(conf, pos, prog, progargs) {
        let char = new Character(this.charidcounter++, conf);
        char.x = pos.x;
        char.z = pos.z;
        this.npcs.push(char);
        return char;
    }
    removeCharacter(chr) {
        let index = this.npcs.indexOf(chr);
        if (index != -1) {
            this.npcs.splice(index, 1);
        }
    }
    *allCharacters() {
        yield* this.npcs;
        // yield* this.players;
    }
}
export function renderWorld(ctx, map, background = true) {
}
export function defaultCharacterConfig() {
    let r = {
        name: "",
        size: 1,
    };
    return r;
}
export function defaultPlayerConfig() {
    let r = {
        ...defaultCharacterConfig(),
        name: "player"
    };
    return r;
}
